import React, { ReactNode } from "react";
import cx from "classnames";
import { navigate } from "gatsby";

import styles from "./index.module.scss";

export interface ButtonProps {
  children: ReactNode;
  variant?: "primary" | "outline" | "inline" | "mika";
  dark?: boolean;
  id?: string;
  to?: string;
  isSmall?: boolean;
  rightIcon?: ReactNode;
  leftIcon?: ReactNode;
  className?: string;
  openInNewTab?: boolean;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = "primary",
  dark = false,
  id,
  isSmall = false,
  leftIcon,
  rightIcon,
  className = "",
  to = "",
  openInNewTab,
  onClick,
  type = "button"
}) => {
  return (
    <button
      id={id}
      type={type}
      className={cx(
        styles.button,
        styles[variant],
        {
          [styles.dark]: dark,
          [styles.small]: isSmall
        },
        className
      )}
      onClick={() => {
        if (onClick) {
          onClick();
        }
        if (to) {
          if (openInNewTab) {
            window.open(to, "_blank", "noopener,noreferrer");
          } else {
            navigate(to);
          }
        }
      }}
    >
      {leftIcon && <span className={styles.IconLeft}>{leftIcon}</span>}
      {children}
      {rightIcon && <span className={styles.IconRight}>{rightIcon}</span>}
    </button>
  );
};

export default Button;
